import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "./en.json";
import pt from "./pt.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import ar from "./ar.json";
import ru from "./ru.json";
import zh from "./zh.json";

Vue.use(VueI18n);

const messages = { en, pt, de, fr, es, ar, ru, zh };

// Cookie 读取
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}

// 确定默认 locale
function detectLocale() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');

    // URL 参数优先：如果 URL 中存在 lang 参数（即使值无效），不再检查 cookie
    if (urlLang && messages[urlLang]) {
        return urlLang;
    }

    // 仅当 URL 参数 lang 不存在时检查 cookie
    if (!urlLang) {
        const cookieLang = getCookie('lang');
        if (cookieLang && messages[cookieLang]) {
            return cookieLang;
        }
    }

    return 'en'; // 默认回退
}

const i18n = new VueI18n({
    fallbackLocale: "en",
    locale: detectLocale(),
    messages
});

export default i18n;
